export default __webpack_public_path__ + "static/banner_back-10d76bad2d654d3591311201a1e74410.webp";